import "./dashboard.css";
import NavigationBar from "../../widgets/navigationBar/NavigationBar.jsx";
import Sidebar from "../../widgets/sidebar/Sidebar.jsx";
import { useState, useRef, useEffect } from "react";
import axios from "axios";
import { adminhost, host } from "../../constants/backendpath.js";
import { useNavigate, useLocation } from "react-router-dom";
import StudentDetails from "../../components/studentDetails/StudentDetails.jsx";
import ScrollToTop from "../../widgets/scrollToTop/ScrollToTop.jsx";
import Chart from "../../widgets/chart/PieChartsDashboard.js";
import CollegeInfo from "../../components/college/CollegeInfo.jsx";
import Branch from "../../components/branch/Branch.jsx";
import AddBranch from "../../components/branch/AddBranch.jsx";
import EditBranch from "../../components/branch/EditBranch.jsx";
import Alert from "../../widgets/alert/Alert";
import { useLoader } from "../../context/LoaderContext";

function Dashboard() {
  const { showLoader, hideLoader } = useLoader();
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [alertMessage, setAlertMessage] = useState("");

  const [current, setCurrent] = useState(
    Number(localStorage.getItem("current")) || 0,
  );
  const [isSubmit, setIsSubmit] = useState(() => {
    const storedCode = localStorage.getItem("collegeCode");
    return (
      storedCode && !["admin", "admin_user", "admin_test"].includes(storedCode)
    );
  });
  const [data, setData] = useState({});
  const [initialData, setInitialData] = useState({});
  const [state, setState] = useState({});
  const [collegeCode, setCollegeCode] = useState(
    localStorage.getItem("collegeCode") || "",
  );
  const [submittedCode, setsubmittedCode] = useState("");
  const [supp, setSupp] = useState(false);
  const scrollRef = useRef();
  const location = useLocation();
  // // console.log(location.state);
  const logged = location.state?.logged || false;

  const navigate = useNavigate();
  useEffect(() => {
    localStorage.setItem("collegeCode", collegeCode);
  }, [collegeCode]);
  useEffect(() => {
    if (
      collegeCode &&
      !["admin", "admin_user", "admin_test"].includes(collegeCode)
    ) {
      fetch();
    }
  }, [isSubmit]);

  const handleCloseAlert = () => {
    setShowAlert(false);
    if (alertType === "success") setCurrent(0);
  };

  async function fetch() {
    setIsSubmit(true);
    try {
      const res = await axios.post(
        `${adminhost}home`,
        { collegeCode },
        { withCredentials: true },
      );
      if (res.status === 200 && res.data && res.data.length > 0) {
        setData(res.data[0]);
        setInitialData(res.data[0]);
      } else {
        setData({});
        setInitialData({});
      }
    } catch (error) {
      console.error(error);
      if (error.status === 401) navigate("/admin/login");
    }
  }

  const handleChange = (e) => {
    const { name, value } = e.target;

    setData((prev) => ({ ...prev, [name]: value }));
  };
  // console.log(data);

  useEffect(() => {
    localStorage.setItem("current", current);
  }, [current]);

  const handleSave = async (data) => {
    showLoader();
    try {
      const changedFields = {};
      Object.keys(data).forEach((key) => {
        if (String(data[key]) !== String(initialData[key])) {
          changedFields[key] = data[key];
        }
      });
      const res = await axios.put(
        `${adminhost}home`,
        { ...changedFields, collegeCode },
        { withCredentials: true },
      );
      if (res.status === 200 || res.status === 201) {
        setInitialData(data);
        setAlertType("success");
        setAlertMessage("Information Updated Successfully");
        setShowAlert(true);
      } else {
        setAlertType("error");
        setAlertMessage("Something went wrong.");
        console.error("Failed to update information");
        setShowAlert(true);
      }
    } catch (err) {
      if (err.response?.status === 405) {
        setAlertType("warning");
        setAlertMessage("No Fields to update!");
      } else if (err.response?.status === 401) {
        navigate("/admin/login");
      } else {
        setAlertType("error");
        setAlertMessage("Server error. Please try again later.");
      }
      setShowAlert(true);
      console.error("update failed : ", err);
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
    if (current === 2) {
      setSupp(true);
    } else {
      setSupp(false);
    }
  }, [current]);

  const handleKey = (e) => {
    if (
      e.key === "Enter" &&
      collegeCode &&
      !["admin", "admin_user", "admin_test"].includes(collegeCode)
    ) {
      setsubmittedCode(collegeCode);
      setCollegeCode(collegeCode);
      // setIsSubmit(true);
      fetch();
    }
  };
  const handleEnterKey = () => {
    if (
      collegeCode &&
      !["admin", "admin_user", "admin_test"].includes(collegeCode)
    ) {
      setsubmittedCode(collegeCode);
      // setIsSubmit(true);
      fetch();
    }
  };

  // console.log(supp);
  const handleLogOut = async (admin) => {
    // console.log('hi')
    try {
      const res = await axios.get(`${host}logout`, { withCredentials: true });
      if (res.status === 200) {
        if (admin) {
          navigate("/admin/login");
        } else {
          navigate("/");
          sessionStorage.setItem("notesShown", "");
          localStorage.setItem("current", 0);
          localStorage.setItem("collegeCode", "");
        }
      }
    } catch (error) {
      // console.log(error);
    }
  };
  // if(collegeCode !== "admin"){
  //   console.log('admin')
  // }
  // console.log(isSubmit);

  return logged ? (
    <div className="dashboard">
      {collegeCode &&
        isSubmit &&
        !["admin", "admin_user", "admin_test"].includes(collegeCode) && (
          <Sidebar setCurrent={setCurrent} admin={true} current={current} />
        )}
      <div className="dashone">
        <NavigationBar
          text={`GOVERNMENT OF TAMILNADU
DIRECTORATE OF TECHNICAL EDUCATION
Tamilnadu Lateral Entry Direct Second Year B.E/B.Tech.,Approval-2026`}
          profile={true}
          bool={false}
          setCurrent={setCurrent}
          admin={true}
          style={{ height: "40px" }}
          login={logged}
          handleLogOut={handleLogOut}
        />

        <div className="dashboard-body" ref={scrollRef}>
          {current == 0 && (
            <div className="dashboard-box">
              <div className="collgroup collgroup-inline">
                <label htmlFor="collcode" className="collcode">
                  College Code
                </label>
                <input
                  type="text"
                  id="collcode"
                  name="collegeCode"
                  className="coll-input"
                  value={
                    collegeCode &&
                    !["admin", "admin_user", "admin_test"].includes(collegeCode)
                      ? collegeCode
                      : ""
                  }
                  placeholder="Enter College Code and Click Enter "
                  onKeyDown={handleKey}
                  onChange={(e) => setCollegeCode(e.target.value)}
                />
                <button className="collbut" onClick={handleEnterKey}>
                  Enter
                </button>
              </div>

              {isSubmit &&
                collegeCode &&
                !["admin", "admin_user", "admin_test"].includes(
                  collegeCode,
                ) && (
                  <>
                    {/* College Name */}
                    <div className="collgroup-full">
                      <label htmlFor="collname" className="coll-label">
                        College Name
                      </label>
                      <input
                        type="text"
                        id="collname"
                        className="coll-input"
                        value={data.name_of_college || ""}
                        readOnly
                      />
                    </div>

                    {/* Office Letter */}
                    {/*<div className="coll-section">
                      <h3 className="coll-heading">Office Letter</h3>
                      <div className="coll-row">
                        <div className="collgroup-half">
                          <label htmlFor="offlet" className="coll-label">
                            Letter No
                          </label>
                          <input
                            type="text"
                            id="offlet"
                            name="letter_no"
                            className="coll-input"
                            value={data.letter_no || ""}
                            onChange={handleChange}
                            readOnly
                          />
                        </div>
                        <div className="collgroup-half">
                          <label htmlFor="letdat" className="coll-label">
                            Dated
                          </label>
                          <input
                            type="text"
                            id="letdat"
                            name="dated"
                            className="coll-input"
                            value={data.dated || ""}
                            onChange={handleChange}
                            readOnly
                          />
                        </div>
                      </div>
                    </div>*/}

                    {/* Office Letter */}
                    <div className="coll-section">
                      <h3 className="coll-heading">Office Letter</h3>
                      <div className="coll-row">
                        <div className="collgroup-half">
                          <label htmlFor="offlet" className="coll-label">
                            Letter No
                          </label>
                          <input
                            type="text"
                            id="offlet"
                            name="file_no"
                            className="coll-input"
                            value={data.file_no || ""}
                            onChange={handleChange}
                      
                          />
                        </div>
                        <div className="collgroup-half">
                          <label htmlFor="letdat" className="coll-label">
                            Dated
                          </label>
                          <input
                            type="text"
                            id="letdat"
                            name="file_dated"
                            className="coll-input"
                            value={data.file_dated || ""}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    {/* Principal Letter */}
                    <div className="coll-section">
                      <h3 className="coll-heading">Principal Letter</h3>
                      <div className="coll-row">
                        <div className="collgroup-half">
                          <label htmlFor="prinlet" className="coll-label">
                            Letter No
                          </label>
                          <input
                            type="text"
                            id="prinlet"
                            name="p_letter_no"
                            className="coll-input"
                            value={data.p_letter_no || ""}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="collgroup-half">
                          <label htmlFor="prindat" className="coll-label">
                            Dated
                          </label>
                          <input
                            type="text"
                            id="prindat"
                            name="p_dated"
                            className="coll-input"
                            value={data.p_dated || ""}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    
                    {/* File no */}
                    {/* <div className="coll-section">
                      <h3 className="coll-heading">File Number</h3>
                      <div className="coll-row">
                        <div className="collgroup-half">
                          <label htmlFor="filno" className="coll-label">
                            File No
                          </label>
                          <input type="text"
                          id = "fileno"
                          name="file_no"
                          className="coll-input"
                          value={data.file_no}
                          onChange={handleChange} />
                        </div>
                      </div>
                    </div> */}

                    {/* Save Button */}
                    <div className="coll-btn-container">
                      <button
                        className="coll-save-btn"
                        onClick={() => {
                          handleSave(data);
                        }}
                      >
                        Save
                      </button>
                    </div>
                  </>
                )}
            </div>
          )}
          {collegeCode &&
            !["admin", "admin_user", "admin_test"].includes(collegeCode) && (
              <>
                {isSubmit && current === 0 && (
                  <Chart collegeCode={collegeCode} key={submittedCode} />
                )}
                {current === 1 && (
                  <StudentDetails
                    admin={true}
                    supp={supp}
                    setCurrent={setCurrent}
                    collegeCode={collegeCode}
                  />
                )}
                {current === 2 && (
                  <StudentDetails
                    admin={true}
                    supp={supp}
                    setCurrent={setCurrent}
                    collegeCode={collegeCode}
                  />
                )}
                {current === 3 && (
                  <CollegeInfo
                    admin={true}
                    collegeCode={collegeCode}
                    setCurrent={setCurrent}
                  />
                )}
                {current === 4 && (
                  <Branch
                    admin={true}
                    collegeCode={collegeCode}
                    setCurrent={setCurrent}
                    setState={setState}
                  />
                )}
                {current === 5 && (
                  <AddBranch
                    admin={true}
                    collegeCode={collegeCode}
                    setCurrent={setCurrent}
                  />
                )}
                {current === 6 && (
                  <EditBranch
                    admin={true}
                    collegeCode={collegeCode}
                    setCurrent={setCurrent}
                    state={state}
                  />
                )}
                <ScrollToTop scrollRef={scrollRef} />
              </>
            )}
        </div>
        <Alert
          type={alertType}
          message={alertMessage}
          show={showAlert}
          okbutton={handleCloseAlert}
        ></Alert>
      </div>
    </div>
  ) : null;
}

export default Dashboard;
